import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("DocumentsStore");
export const useDocumentsStoreActions = useActions;
export const useDocumentsStoreGetters = useGetters;
export const useDocumentsStoreMutations = useMutations;
export const useDocumentsStoreState = useState;